import { render, staticRenderFns } from "./shift-authorizations-modal.vue?vue&type=template&id=e2fde686&"
import script from "./shift-authorizations-modal.vue?vue&type=script&lang=js&"
export * from "./shift-authorizations-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports